/** @format */
import {CommonChartData} from '../model/charts';

const logScale = (value: number) => Math.log10(value <= 0 ? 1 : value);

const getLogarithmicData = (data: CommonChartData[]): CommonChartData[] => {
  return data.map(item => {
    const newItem: CommonChartData = {
      ...item,
    };
    if (item.primary !== undefined) {
      newItem.primary = logScale(item.primary);
    }
    if (item.line !== undefined) {
      newItem.line = logScale(item.line);
    }
    if (item.average !== undefined) {
      newItem.average = logScale(item.average);
    }
    if (item.range) {
      newItem.range = [logScale(item.range[0]), logScale(item.range[1])];
    }
    return newItem;
  });
};

export {getLogarithmicData};
